


import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2';
import '../../App.css';
import BrandHeader from "./BrandHeader";
import Navbar from "./Navbar";
const CreateCampaign = () => {
  const [campaignData, setCampaignData] = useState({
    campaignName: "",
    campaignType: "",
    startDate: "",
    endDate: "",
    budget: "",
    description: "",
    followerRange: ["", ""],
    task: "",
    tags: []
  });
 const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [campaignImages, setCampaignImages] = useState([]);  // For images
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCampaignData({
      ...campaignData,
      [name]: value,
    });
  };

  // Handle follower range changes
  const handleFollowerRangeChange = (e) => {
    const { name, value } = e.target;
    const newFollowerRange = [...campaignData.followerRange];
    if (name === "min") {
      newFollowerRange[0] = value;
    } else if (name === "max") {
      newFollowerRange[1] = value;
    }
    setCampaignData({
      ...campaignData,
      followerRange: newFollowerRange,
    });
  };

  // Handle tag input changesssssssdddddd
  const handleTagInputChange = (e) => setTagInput(e.target.value);

  // Add new tag when user presses enter
  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedTag = tagInput.trim();
      if (trimmedTag && !campaignData.tags.includes(trimmedTag)) {
        setCampaignData({
          ...campaignData,
          tags: [...campaignData.tags, trimmedTag],
        });
        setTagInput("");
      } else {
        toast.error("Tag is empty or already exists!");
      }
    }
  };

  // Remove tag
  const handleRemoveTag = (tag) => {
    setCampaignData({
      ...campaignData,
      tags: campaignData.tags.filter((t) => t !== tag),
    });
  };

  // Handle file input changessss
  const handleImageChange = (e) => {
    setCampaignImages(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate fields
    if (
      !campaignData.campaignName ||
      !campaignData.campaignType ||
      !campaignData.startDate ||
      !campaignData.endDate ||
      !campaignData.budget ||
      !campaignData.followerRange[0] ||
      !campaignData.followerRange[1] ||
      campaignData.tags.length === 0 ||
      !campaignData.task
    ) {
      toast.error("Please fill out all required fields.");
      return;
    }

    if (campaignImages.length === 0) {
      toast.error("Please upload at least one campaign image.");
      return;
    }

    setLoading(true);

    try {
      const storedBrandId = localStorage.getItem("brandID");

      // Create form data for multipart/form-data
      const formData = new FormData();

      formData.append("campaignName", campaignData.campaignName);
      formData.append("campaignType", campaignData.campaignType);
      formData.append("startDate", new Date(campaignData.startDate).toISOString());
      formData.append("endDate", new Date(campaignData.endDate).toISOString());
      formData.append("budget", campaignData.budget);
      formData.append("description", campaignData.description);
      formData.append("task", campaignData.task);
      formData.append("followerRange", JSON.stringify(campaignData.followerRange));
      formData.append("tags", JSON.stringify(campaignData.tags));

      // Append images
      campaignImages.forEach((file) => {
        formData.append("campaignImages", file);
      });

      const response = await fetch(`https://server-side-influencer.onrender.com/brand/createCampaign/${storedBrandId}`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        Swal.fire({
          title: "Success",
          text: "Campaign created successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // Optionally navigate or reset form heres
        
        });
      } else {
        const errorData = await response.json();
        toast.error(errorData.error || "An error occurred. Please try again.");
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      console.error("Error:", error);
    }

    setLoading(false);
  };

    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 720);
      };
  
      handleResize(); // Check initial sizess
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  return (
    <div className="flex h-screen mb-0 justify-center items-center w-full page-scroll ">
      {/* Navbar */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* BrandHeader */}
      <div className="absolute top-0 left-0 w-full z-40 ml-0">
        <BrandHeader page="create campaign" />
      </div>

      {/* Main Content sss*/}
      <div className="ml-0 w-full max-w-3xl h-full relative z-0 mt-[140px] "style={{ marginLeft: isSmallScreen ?'0px':'45px'}}>
        <div className="max-w-full mx-auto p-6 bg-white shadow-lg rounded-lg w-full">
          <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Create Campaign</h2>

          <form onSubmit={handleSubmit}>
            <div className="space-y-6 mb-4">
              {/* Other inputs (campaignName, campaignType, etc.) */}
              {/* ...Your existing inputs remain unchanged */}

              {/* Campaign Name */}
              <div>
                <label htmlFor="campaignName" className="block text-sm font-medium text-gray-900">Campaign Name</label>
                <input
                  type="text"
                  name="campaignName"
                  value={campaignData.campaignName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Campaign name"
                  required
                />
              </div>

              {/* Campaign Type */}
              <div>
                <label htmlFor="campaignType" className="block text-sm font-medium text-gray-900">Campaign Type</label>
                <input
                  type="text"
                  name="campaignType"
                  value={campaignData.campaignType}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Campaign type"
                  required
                />
              </div>

              {/* Start Date */}
              <div>
                <label htmlFor="startDate" className="block text-sm font-medium text-gray-900">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={campaignData.startDate}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* End Date */}
              <div>
                <label htmlFor="endDate" className="block text-sm font-medium text-gray-900">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={campaignData.endDate}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Budget */}
              <div>
                <label htmlFor="budget" className="block text-sm font-medium text-gray-900">Budget</label>
                <input
                  type="number"
                  name="budget"
                  value={campaignData.budget}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter budget"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-900">Description</label>
                <textarea
                  name="description"
                  value={campaignData.description}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Campaign description"
                  rows="4"
                ></textarea>
              </div>

              {/* Task */}
              <div>
                <label htmlFor="task" className="block text-sm font-medium text-gray-900">Task</label>
                <textarea
                  name="task"
                  value={campaignData.task}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                  placeholder="Enter task details"
                />
              </div>

              {/* Follower Range */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="minFollowers" className="block text-sm font-medium text-gray-900">Min Followers</label>
                  <input
                    type="number"
                    name="min"
                    value={campaignData.followerRange[0]}
                    onChange={handleFollowerRangeChange}
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Min followers"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="maxFollowers" className="block text-sm font-medium text-gray-900">Max Followers</label>
                  <input
                    type="number"
                    name="max"
                    value={campaignData.followerRange[1]}
                    onChange={handleFollowerRangeChange}
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Max followers"
                    required
                  />
                </div>
              </div>

              {/* Tags Section */}
              <div>
                <label htmlFor="tags" className="block text-sm font-medium text-gray-900">Tags</label>
                <input
                  type="text"
                  value={tagInput}
                  onChange={handleTagInputChange}
                  onKeyDown={handleTagKeyDown}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter tags"
                />
                <div className="mt-2">
                  {campaignData.tags.map((tag, index) => (
                    <span key={index} className="inline-block px-2 py-1 bg-blue-200 rounded-full mr-2">
                      {tag}
                      <button
                        type="button"
                        onClick={() => handleRemoveTag(tag)}
                        className="ml-2 text-red-500"
                      >
                        x
                      </button>
                    </span>
                  ))}
                </div>
              </div>

              {/* Image Upload Section */}
              <div>
                <label htmlFor="campaignImages" className="block text-sm font-medium text-gray-900 mb-2">
                  Upload images related to this campaign
                </label>
                <input
                  type="file"
                  id="campaignImages"
                  name="campaignImages"
                  accept="image/*"
                  multiple
                  onChange={handleImageChange}
                  className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                />
                {campaignImages.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-2">
                    {campaignImages.map((file, idx) => (
                      <div key={idx} className="text-sm text-gray-700">
                        {file.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex items-center justify-center">
              <button
                type="submit"
                className="flex items-center justify-center gap-2 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-12"
                disabled={loading}
              >
                {!loading && <AddIcon style={{ fontSize: 18 }} />}
                {loading ? "Creating..." : "Create Campaign"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default CreateCampaign;
